import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";
import { toast } from "react-toastify";
import { AuthService } from "../services";
import { Link } from "react-router-dom";
import { Routes } from "../../constants";

function ForgotPassword(props) {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleEmailChange = (e) => {
    e.preventDefault();
    const val = e.target.value.trim();
    if (val === "") {
      setError("Email is required");
    } else if (!emailRegex.test(val)) {
      setError("Email is not valid");
    } else {
      setError("");
    }

    setEmail(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    props.application.setLoading(true, "Please wait!");
    let valid = true;
    if (email.trim() === "") {
      setError("Email is required");
      valid = false;
    } else if (!emailRegex.test(email)) {
      setError("Please enter the correct Email!");
      valid = false;
    } else {
      setError("");
    }
    if (!valid) {
      props.application.setLoading(false, "Please wait!");
      return;
    } else {
      try {
        const data = {
          email: email,
        };
        props.application.setLoading(true, "Please wait!");
        const response = await AuthService.ForgotPassword(data);
        if (response.success === true) {
          props.application.setLoading(false, "Please wait!");
          toast.dismiss();
          toast.success("Email has been sent successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
          localStorage.setItem("email", email);
          localStorage.setItem("reset_password", true);
          navigate("/auth/reset-password");
        } else {
          setError(response.message);
          props.application.setLoading(false, "Please wait!");
        }
      } catch (error) {
        props.application.setLoading(false, "Please wait!");
        console.log(error);
        setError(error.response.data.message);
        setSuccessMessage("");
      }
    }
  };
  return (
    <main>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center py-4 lf-logo">
                  <a
                    href="index.html"
                    className="lf-logo d-flex align-items-center w-auto"
                  >
                    <img src="/assets/img/logo.png" alt="" />
                  </a>
                </div>
                <div className="card login-form mb-3">
                  <div className="card-body p-4">
                    <div className="pt-1 pb-0">
                      <h5 className="card-title text-center pb-2 fs-4">
                        Forgot Password
                      </h5>
                      <p className="pt-0 pb-0">
                        You forgot your password? Here you can easily retrieve a
                        new password.
                      </p>
                    </div>
                    <form
                      className="row g-2 needs-validation account-login"
                      onSubmit={handleSubmit}
                    >
                      <div className="col-12">
                        <label htmlFor="yourUsername" className="form-label">
                          Email<span className="aestrick">*</span>
                        </label>
                        <div className="input-group has-validation">
                          <span
                            className="input-group-text"
                            id="inputGroupPrepend"
                          >
                            <i className="fa-regular fa-envelope"></i>{" "}
                          </span>
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            id="yourUsername"
                            placeholder="Email*"
                            autoComplete="off"
                            value={email}
                            onChange={handleEmailChange}
                          />
                          <div className="invalid-feedback">
                            Please enter your Email ID.
                          </div>
                        </div>
                      </div>
                      {successMessage && (
                        <span className="error" style={{ color: "red" }}>
                          {successMessage}
                        </span>
                      )}
                      {error && (
                        <span className="error" style={{ color: "red" }}>
                          {error}
                        </span>
                      )}
                      <div className="col-12 login">
                        <button className="btn btn-primary w-100" type="submit">
                          Request new password
                        </button>
                      </div>
                      <div className="col-12 text-center create-account">
                        <p className="small mb-0">
                          <Link to={Routes.DEFAULT} className="ac-new">
                            Login
                          </Link>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
export default injectModels(["application"])(ForgotPassword);
